import { Badge, Button, Dropdown, Spin, Typography } from "antd";
import { useAppMessage } from "../../hooks/useAppMessage";
import {
  GroupOutlined,
  FilterFilled,
  ExportOutlined,
  EllipsisOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import React, {
  useDeferredValue,
  useCallback,
  useEffect,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import HistoryTable from "../../Components/HistoryTable/HistoryTable";
import { HistoryFilter } from "../../Components/modals/HistoryFilter";
import { EscalationCompletedAPI } from "../../API/EscalationCompletedAPI";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { exportToExcelFun } from "../../Components/Utils/ExportToExl";
import { EscalatedSelectedColumns } from "../../Components/modals/EscalatedSelectedColumns";
import { DEFUALT_COLUMNS, keyLabelMap } from "./EscalationCompletedUtils";
import BottomTab from "../../Components/BottomTab/BottomTab";
import { useFlightModel } from "../../contexts/FlightModelContext";
const { Text } = Typography;

export const EscalationCompleted = () => {
  const navigate = useNavigate();
  const [messageApi, contextHolder] = useAppMessage();
  const [HistoryData, setHistoryData] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState(DEFUALT_COLUMNS);
  const [openselectColumns, setOpenSelectColumns] = useState(false);
  const [openHistoryFilter, setOpenHistoryFilter] = useState(false);
  const [defualtData, setDefualtData] = useState([]);
  const [serachVal, setSearchVal] = useState("");
  const [spinning, setSpinning] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredValues, setFilteredvalues] = useState({
    cat: "",
    specType: "",
    // yieldValue: 90,
    yieldValueFrom: 0,
    yieldValueTo: 100,
    maintenanceCheck: "",
    maintenanceCheckPackage: "",
    maintenanceCheckInterval: "",
    maintenanceCheckPackageInterval: "",
  });
   const { selectedFlightModel, refreshFlightModels } = useFlightModel();
  const [filterStatus, setFilterStatus] = useState(false);

  const messageToast = useCallback(
    (type, message) => {
      messageApi.open({
        type: type,
        content: message,
        duration: 6,
      });
    },
    [messageApi],
  );

  const serachFun = useCallback(async () => {
       let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
    const queryParams = {
      params: {
        flight_model: flightModelToUse,
        // localStorage.getItem("flight_model"),
        page: 1,
        page_size: pageSize,
        search: serachVal,
      },
    };
    setSpinning(true);
    await EscalationCompletedAPI.getEscalationList(queryParams)
      .then((res) => {
        if (res.data.status === true) {
          const sorted = res.data.data.sort((a, b) => {
            const aDate = new Date(a.escalated_on);
            const bDate = new Date(b.escalated_on);

            return bDate.getTime() - aDate.getTime();
          });
          setHistoryData(sorted);
          setTotalRecords(res.data.total);
          setPage(res.data.page);
          setPageSize(res.data.page_size);
          setDefualtData(sorted);
        } else {
          messageToast("error", res.data?.message);
        }
      })
      .catch((err) => {
        messageToast("error", "Internal Server Error");
      })
      .finally(() => {
        setSpinning(false);
      });
  }, [serachVal, messageToast, pageSize]);

  const deferredQuery = useDeferredValue(serachVal);
  useEffect(() => {
    serachFun();
  }, [deferredQuery, serachFun]);

  const getHistoryData = useCallback(
    async function getHistoryData(pageNo, pageCount) {
         let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
      const queryParams = {
        params: {
          flight_model:flightModelToUse,
          //  localStorage.getItem("flight_model"),
          page: pageNo,
          page_size: pageCount,
          search: serachVal,
        },
      };
      setSpinning(true);
      await EscalationCompletedAPI.getEscalationList(queryParams)
        .then((res) => {
          if (res.data.status === true) {
            const sorted = res.data.data.sort((a, b) => {
              const aDate = new Date(a.escalated_on);
              const bDate = new Date(b.escalated_on);

              return bDate.getTime() - aDate.getTime();
            });
            setHistoryData(sorted);
            setTotalRecords(res.data.total);
            setPage(res.data.page);
            setPageSize(res.data.page_size);
            setDefualtData(sorted);
          } else {
            messageToast("error", res.data?.message);
          }
        })
        .catch((err) => {
          messageToast("error", "Internal Server Error");
        })
        .finally(() => {
          setSpinning(false);
        });
    },
    [serachVal, messageToast],
  );

  useEffect(() => {
    setSpinning(true);
    getHistoryData(page, pageSize);
  }, [getHistoryData, page, pageSize]);

  async function exportExcel() {
    setSpinning(true);
    try {
         let flightModelToUse = selectedFlightModel;

    // fallback from context
    if (!flightModelToUse) {
      const refreshed = await refreshFlightModels();
      flightModelToUse = refreshed?.selectedFlightModel || null;
    }

    if (!flightModelToUse) {
      messageToast("error", "No flight model selected.");setSpinning(false);
      return;
    }
      const queryParams = {
        params: {
          flight_model: flightModelToUse,
          // localStorage.getItem("flight_model"),
          page: page,
          page_size: pageSize,
          search: serachVal,
          export: true,
        },
      };

      const response =
        await EscalationCompletedAPI.exportEscalationList(queryParams);

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Extract filename from content-disposition header if provided by backend
      const contentDisposition = response.headers["content-disposition"];
      let fileName = "EscalationCompleted_export.xlsx";
      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=(['"]?)([^'"\n;]*)\1/,
        );
        if (match?.[2]) fileName = match[2].trim();
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
      messageToast("error", "Export failed. Please try again.");
    } finally {
      setSpinning(false);
    }
  }

  return (
    <div className="container_div">
      <Helmet>
        <title>SpecOptimizer | Optimization Completed</title>
      </Helmet>
      <HeaderTab />

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
          marginTop: "10px",
        }}
      >
        <Text strong style={{ fontSize: "17px" }}>
          Ranking - Optimization Completed{" "}
        </Text>
        <Button
          onClick={() => navigate("/")}
          type="default"
          style={{
            margin: "0px 10px",
            color: "#304CB2",
            borderColor: "#304CB2",
            backgroundColor: "transparent",
          }}
        >
          Back
        </Button>
      </div>

      <Spin spinning={spinning}>
        <div className="box_wraper_div">
          <div className="table_head_wraper">
            <Text className="table_head">
              List of Optimization Completed Specs{" "}
            </Text>
            <div className="table_custom_buttons">
              <div
                style={{
                  borderRadius: "25px",
                  backgroundColor: "#EBEEF8",
                  color: "#737373",
                  display: "flex",
                  marginRight: "10px",
                  flex: "1 1 0px ",
                }}
              >
                <input
                  value={serachVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                  className="searc_input"
                />
                <SearchOutlined
                  className="search_btn"
                  style={{
                    color: !serachVal ? "#737373" : "#ff4d4f",
                    fontSize: "18px",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              </div>
              <Dropdown
                placement="bottomRight"
                menu={{
                  items: [
                    // {
                    //   key: "1",
                    //   label: (
                    //     <div
                    //       onClick={() => setOpenSelectColumns(true)}
                    //       style={{ fontSize: "18px", minWidth: "150px" }}
                    //     >
                    //       <GroupOutlined />{" "}
                    //       <Text style={{ marginLeft: "10px" }}>Columns</Text>
                    //     </div>
                    //   ),
                    // },
                    // {
                    //   key: "2",
                    //   label: (
                    //     <div
                    //       onClick={() => setOpenHistoryFilter(true)}
                    //       style={{ fontSize: "18px", minWidth: "150px" }}
                    //     >
                    //       <Badge dot={filterStatus}>
                    //         <FilterFilled />{" "}
                    //       </Badge>{" "}
                    //       <Text style={{ marginLeft: "10px" }}>Filter</Text>
                    //     </div>
                    //   ),
                    // },
                    {
                      key: "3",
                      label: (
                        <div
                          onClick={exportExcel}
                          style={{ fontSize: "18px", minWidth: "150px" }}
                        >
                          <ExportOutlined />{" "}
                          <Text style={{ marginLeft: "10px" }}>
                            Export to Excel
                          </Text>
                        </div>
                      ),
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Badge dot={filterStatus}>
                  <Button
                    // disabled={defualtData.length > 0 ? false : true}
                    type="primary"
                    style={{ backgroundColor: "#EBEEF8", color: "#304CB2" }}
                    icon={<EllipsisOutlined />}
                  >
                    Actions
                  </Button>
                </Badge>
              </Dropdown>
            </div>
          </div>

          <HistoryTable
            listData={HistoryData}
            selectedColumns={selectedColumns}
            page={page}
            pageSize={pageSize}
            totalRecords={totalRecords}
            getHistoryDataFun={getHistoryData}
            filteredValues={filteredValues}
            serachVal={""}
            setPage={setPage}
            setPageSize={setPageSize}
            setTotalRecords={setTotalRecords}
            setHistoryData={setHistoryData}
            pageType="EscalationCompleted"
          />

          <EscalatedSelectedColumns
            open={openselectColumns}
            setOpen={setOpenSelectColumns}
            selectedColumns={selectedColumns}
            setSelectedColumns={setSelectedColumns}
            getRankingDataFun={getHistoryData}
            defualtColumns={DEFUALT_COLUMNS}
          />
          <HistoryFilter
            open={openHistoryFilter}
            setOpen={setOpenHistoryFilter}
            listData={HistoryData}
            setListData={setHistoryData}
            defualtData={defualtData}
            filteredValues={filteredValues}
            setFilteredvalues={setFilteredvalues}
            serachVal={serachVal}
            setFilterStatus={setFilterStatus}
            page="EscalationCompleted"
            pageSize={pageSize}
            pageNo={page}
          />
        </div>
      </Spin>

      <BottomTab />
      {contextHolder}
    </div>
  );
};
